<template>
  <div>
    <el-card>
      <el-form :model="filter" inline size="small" label-width="100px">
        <el-form-item label="班级名称">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称" clearable />
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input v-model="filter.name" placeholder="请输入学员姓名" clearable />
        </el-form-item>
        <el-form-item label="提交时间">
          <my-datePicker :scopeDate="submitDate" @receiveMyDate="receiveSubmitDate" />
        </el-form-item>
        <el-form-item label="作业状态">
          <el-select v-model="filter.assignmentStatus" placeholder="请选择作业状态">
            <el-option label="全部" :value="null" />
            <el-option label="未通过" :value="1" />
            <el-option label="已通过" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="学员手机号">
          <el-input v-model="filter.phone" placeholder="请输入学员手机号" clearable />
        </el-form-item>
        <el-form-item label="判卷状态">
          <el-select v-model="filter.gradingStatus" placeholder="请选择作业状态">
            <el-option label="全部" :value="null" />
            <el-option label="未判卷" :value="1" />
            <el-option label="已判卷" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="判卷老师">
          <el-input v-model="filter.gradingTeacher" placeholder="请输入判卷老师" clearable />
        </el-form-item>
        <el-form-item label-width="120px" label="">
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <br>
      <el-row type="flex">
        <el-row type="flex" align="middle">
          <el-button type="primary" :disabled="multipleSelection.length === 0" size="small" @click="batchPublish">批量发布成绩</el-button>&nbsp;
          <span v-if="multipleSelection.length">已选: {{ multipleSelection.length }}条数据</span>&emsp;
        </el-row>
        <el-button size="small" @click="handleExport">导出</el-button>
        <el-button type="primary" size="small" @click="editStandard">成绩标准配置</el-button>
        <el-button type="primary" size="small" @click="editExerciseConf">作业类型配置</el-button>
      </el-row>
      <el-table
        :data="tableData"
        border style="margin-top:10px"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :reserve-selection="true" :selectable="checkSelectable" width="55" align="center" />
        <el-table-column align="center" label="班级名称" prop="skuName" min-width="150px" :formatter="fliteRData" />
        <el-table-column align="center" label="学员姓名" prop="name" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="学员手机号" prop="phone" min-width="140px" :formatter="fliteRData" />
        <el-table-column align="center" label="作业类型" min-width="120px">
          <template v-slot="{ row }">
            <span>{{ row.exerciseTypeName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="判卷状态" min-width="120px">
          <template v-slot="{ row }">
            <span v-if="row.gradingStatus === 1">未判卷</span>
            <span v-else-if="row.gradingStatus === 2">已判卷</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="作业成绩" prop="practicalScore" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="作业状态" prop="assignmentStatus" min-width="120px">
          <template v-slot="{ row }">
            <span v-if="row.assignmentStatus === 1">未通过</span>
            <span v-else-if="row.assignmentStatus === 2">已通过</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="成绩发布状态" min-width="120px">
          <template v-slot="{ row }">
            <span v-if="row.publishStatus === 1">未发布</span>
            <span v-else-if="row.publishStatus === 2">已发布</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="判卷老师" prop="gradingTeacher" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="最新提交时间" prop="lastSubmitDate" min-width="156px" :formatter="fliteRData" />
        <el-table-column align="center" label="最新判卷时间" prop="lastUpdateDate" min-width="156px" :formatter="fliteRData" />
        <el-table-column align="center" label="操作" min-width="260px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="toGrading(row)">作业判卷</el-button>
            <el-button v-if="row.gradingStatus === 2" type="text" size="mini" @click="viewGradingRecord(row.id)">判卷记录</el-button>
            <el-button type="text" size="mini" @click="viewWorkRecord(row)">作业记录</el-button>
            <el-button v-if="row.publishStatus === 1" type="text" size="mini" @click="handlePublish(row.id)">发布成绩</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        @size-change="handlePageSize"
        @current-change="handlePage"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 操作Dialog -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisable" width="760px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseDialog"
    >
      <p v-if="type === 'showGrading'" class="dilog-module-title">作业记录</p>
      <el-form :model="recordFilter" inline size="small" label-width="80px">
        <el-form-item label="操作时间">
          <my-datePicker :scopeDate="operateDate" @receiveMyDate="receiveOperateDate" />
        </el-form-item>
        <el-form-item label-width="120px" label="">
          <el-button type="primary" size="small" @click="searchWorkRecord">搜索</el-button>
          <el-button type="" size="small" @click="resetWorkRecord">重置</el-button>
        </el-form-item>
      </el-form>
      <br>
      <el-table :data="workRecordData" border>
        <el-table-column align="center" label="学员姓名" prop="name" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="操作时间" prop="insertDate" min-width="156px" :formatter="fliteRData" />
        <el-table-column align="center" label="作业类型" min-width="120px">
          <template v-slot="{ row }">
            <span>{{ row.exerciseTypeId | filterTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="作业链接" prop="exerciseLink" min-width="200px" />
      </el-table>
      <br>
      <el-pagination
        @size-change="handleRecordPageSize"
        @current-change="handleRecordPage"
        :current-page="recordFilter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="recordFilter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordFilter.total"
      />
      <template v-if="type === 'showGrading'">
        <br>
        <!-- 作业判卷 -->
        <p class="dilog-module-title">作业判卷</p>
        <el-form v-show="targetGradingStatus === 1" ref="scoreFormEl" :model="scoreForm" :rules="formRules" size="small" label-width="120px">
          <el-form-item label="内容创作：" prop="practicalContentCreation">
            <el-input-number v-model="scoreForm.practicalContentCreation" @input.native="changeInput($event)" :step="0.1" :min="0" :max="10" :controls="false" placeholder="得分范围为0-10分" style="width:146px" />
            <span> 分</span>
          </el-form-item>
          <el-form-item label="语言表达：" prop="practicalLanguageExpression">
            <el-input-number v-model="scoreForm.practicalLanguageExpression" @input.native="changeInput($event)" :step="0.1" :min="0" :max="30" :controls="false" placeholder="得分范围为0-30分" style="width:146px" />
            <span> 分</span>
          </el-form-item>
          <el-form-item label="镜头表现：" prop="practicalScreenPresence">
            <el-input-number v-model="scoreForm.practicalScreenPresence" @input.native="changeInput($event)" :step="0.1" :min="0" :max="30" :controls="false" placeholder="得分范围为0-30分" style="width:146px" />
            <span> 分</span>
          </el-form-item>
          <el-form-item label="数据分析：" prop="practicalDataAnalysis">
            <el-input-number v-model="scoreForm.practicalDataAnalysis" @input.native="changeInput($event)" :step="0.1" :min="0" :max="20" :controls="false" placeholder="得分范围为0-20分" style="width:146px" />
            <span> 分</span>
          </el-form-item>
          <el-form-item label="策划运营：" prop="practicalPlanOperation">
            <el-input-number v-model="scoreForm.practicalPlanOperation" @input.native="changeInput($event)" :step="0.1" :min="0" :max="10" :controls="false" placeholder="得分范围为0-10分" style="width:146px" />
            <span> 分</span>
          </el-form-item>
          <el-form-item label="老师点评：" prop="teacherComment">
            <el-input
              v-model="scoreForm.teacherComment"
              type="textarea"
              placeholder="请输入老师点评"
              :rows="4"
              maxlength="400"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <!-- 作业判卷 - 已判卷 -->
        <el-form v-show="targetGradingStatus === 2" ref="scoreFormEl" :model="scoreForm" :rules="formRules" size="small" label-width="120px">
          <el-form-item label="内容创作：" prop="practicalContentCreation">
            <span class="red">{{ scoreForm.practicalContentCreation }}/10</span>
            <span>得分/总分</span>
          </el-form-item>
          <el-form-item label="语言表达：" prop="practicalLanguageExpression">
            <span class="red">{{ scoreForm.practicalLanguageExpression }}/30</span>
            <span>得分/总分</span>
          </el-form-item>
          <el-form-item label="镜头表现：" prop="practicalScreenPresence">
            <span class="red">{{ scoreForm.practicalScreenPresence }}/30</span>
            <span>得分/总分</span>
          </el-form-item>
          <el-form-item label="数据分析：" prop="practicalDataAnalysis">
            <span class="red">{{ scoreForm.practicalDataAnalysis }}/20</span>
            <span>得分/总分</span>
          </el-form-item>
          <el-form-item label="策划运营：" prop="practicalPlanOperation">
            <span class="red">{{ scoreForm.practicalPlanOperation }}/10</span>
            <span>得分/总分</span>
          </el-form-item>
          <el-form-item label="得分：" prop="practicalScore">
            <span class="red">{{ targetPracticalScore }}/100</span>
            <span>得分/总分</span>
          </el-form-item>
          <el-form-item label="老师点评：" prop="teacherComment">
            <span>{{ scoreForm.teacherComment || '--' }}</span>
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer">
        <template v-if="targetGradingStatus === 1">
          <el-button :loading="saveing" type="primary" size="small" @click="handleSubmit(2)">确认判卷并发布成绩</el-button>
          <el-button :loading="saveing" type="primary" size="small" @click="handleSubmit(1)">确认判卷</el-button>
        </template>
        <el-button v-else-if="targetGradingStatus === 2" type="primary" size="small" @click="handleReGrading">重新判卷</el-button>
        <el-button size="small" @click="handleCloseDialog">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 成绩标准配置 -->
    <el-dialog
      title="成绩标准配置"
      :visible.sync="dialogStandardVisable" width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseStandardDialog"
    >
      <el-row type="flex" align="middle">
        <p>总分成绩大于等于&emsp;</p>
        <el-input-number v-model="standardEditForm.score" @input.native="changeInput($event)" :step="0.1" :min="0" :max="100" :controls="false" size="small" placeholder="请输入分数，可输入0-100" />
        <p>&emsp;分时，成绩为合格</p>
      </el-row>
      <div slot="footer">
        <el-button type="primary" size="small" @click="submitStandardEdit">保存并更新</el-button>
        <el-button size="small" @click="handleCloseStandardDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 作业了类型配置 -->
    <el-dialog
      title="作业类型配置"
      :visible.sync="dialogExerciseConfVisable" width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseExerciseConfDialog"
    >
      <el-row v-for="(item, index) of exerciseConfList" :key="item.key" type="flex" align="middle" style="margin-bottom:10px">
        <p>作业类型名称:&emsp;</p>
        <el-input v-model="item.name" maxlength="100" placeholder="请输入作业类型名称" size="small" style="width:240px" clearable />
        <div style="width:30px;text-align:center">
          <i v-if="index === exerciseConfList.length - 1" class="el-icon-circle-plus-outline" @click="handleAddExerciseConfLine" />
        </div>
        <el-button type="text" size="mini" @click="handleSaveExerciseConf(item)">保存</el-button>
        <el-button v-if="exerciseConfList.length !== 1" v-loading="saveing" type="text" size="mini" @click="handleDelExerciseConf(item.id, index)">删除</el-button>
      </el-row>
      <div slot="footer">
        <el-button size="small" @click="handleCloseExerciseConfDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 判卷记录 -->
    <Record ref="RecordEl" />
    <!-- 判卷记录 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import myDatePicker from "@/components/myDatePicker.vue"
import FileExport from "@/components/FileExport.vue"
import Record from './record.vue'
import {
  getPracticalWorkListPage,
  getExerciseRecordListPage,
  getScoreConf,
  updateScoreConf,
  getExerciseConfList,
  saveExerciseConf,
  delExerciseConf,
  gradingPractical,
  publishGrading,
  batchPublishGrading
} from "@/api/product/testPlanItem"
import { add } from '@/utils/handle'
let exerciseConfList = []

export default {
  name: 'WorkManage',

  components: { myDatePicker, FileExport, Record },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        skuName: null,
        name: null,
        submitDateStart: null,
        submitDateEnd: null,
        assignmentStatus: null,
        phone: null,
        gradingStatus: null,
        gradingTeacher: null
      },
      submitDate: [],
      total: 0,
      tableData: [],
      multipleSelection: [],
      saveing: false,
      dialogVisable: false,
      dialogTitle: '',
      recordFilter: {
        page: 1,
        limit: 10,
        total: 0
      },
      operateDate: [],
      workRecordData: [],
      scoreForm: {
        practicalContentCreation: undefined,
        practicalLanguageExpression: undefined,
        practicalScreenPresence: undefined,
        practicalDataAnalysis: undefined,
        practicalPlanOperation: undefined,
        teacherComment: ''
      },
      formRules: {
        practicalContentCreation: [{ required: true, message: '请输入内容创作分!', trigger: 'blur' }],
        practicalLanguageExpression: [{ required: true, message: '请输入语言表达分!', trigger: 'blur' }],
        practicalScreenPresence: [{ required: true, message: '请输入镜头表现分!', trigger: 'blur' }],
        practicalDataAnalysis: [{ required: true, message: '请输入数据分析分!', trigger: 'blur' }],
        practicalPlanOperation: [{ required: true, message: '请输入策划运营分!', trigger: 'blur' }],
      },
      targetPracticalScore: 0,
      type: '',
      targetPracticalId: '',
      targetGradingStatus: 0,
      dialogStandardVisable: false,
      standardEditForm: { score: null },
      dialogExerciseConfVisable: false,
      exerciseConfList: [],
    }
  },
  created () {
    this.handleGetExerciseConfList().then(() => {
      this.getListPage()
    })
  },
  methods: {
    search() {
      this.filter.page = 1
      this.getListPage()
    },
    reset () {
      this.submitDate = []
      this.filter = this.$options.data().filter
      this.getListPage()
    },
    async getListPage () {
      const { data } = await getPracticalWorkListPage(this.filter)
      const { records, total } = data
      this.total = Number(total)
      this.tableData = records
    },
    // 导出
    handleExport () {
      const prams = { ...this.filter }
      delete prams.page
      delete prams.limit
      this.$refs.FileExport.init(
        prams, // 搜索表单参数
        "jsw-product-provider", // 后端对应业务线服务
        "/adm/practicalInfo/export", // 导出-对应的接口
        1, //  状态：0get、1post
        "实操作业列表.xlsx" //文件名称
      )
    },
    // 成绩标准配置
    editStandard () {
      getScoreConf().then(({ code, data }) => {
        if (code === 0) {
          this.standardEditForm.id = data.id
          this.standardEditForm.score = data.score
        }
      })
      this.dialogStandardVisable = true
    },
    // 提交成绩标准配置
    submitStandardEdit () {
      if (this.standardEditForm.score || standardEditForm.score === 0) {
        updateScoreConf(this.standardEditForm).then(({ code }) => {
          if (code === 0) {
            this.$message.success('更新成绩标准配置成功!')
          }
        })
      } else {
        this.$message.warning('请输入分数，可输入0-100!')
      }
    },
    // 作业类型配置
    editExerciseConf () {
      this.dialogExerciseConfVisable = true
    },
    // 获取作业类型配置
    handleGetExerciseConfList () {
      return getExerciseConfList().then(({ code, data }) => {
        if (code === 0 && data && data.length !== 0) {
          this.exerciseConfList = data
          exerciseConfList = data
        } else {
          this.exerciseConfList = [{
            key: new Date().getTime(),
            name: ''
          }]
        }
        return
      })
    },
    // 添加作业类型配置项
    handleAddExerciseConfLine () {
      this.exerciseConfList.push({ key: new Date().getTime(), name: '' })
    },
    // 删除作业类型配置
    handleDelExerciseConf (id, index) {
      this.$confirm('确认删除', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.saveing = true
        if (id) {
          await delExerciseConf({ id })
        }
        this.$message.success('删除成功!')
        this.exerciseConfList.splice(index, 1)
        this.saveing = false
      })
    },
    // 保存作业类型配置
    handleSaveExerciseConf (row) {
      if (!row.name) {
        this.$message.warning('请输入作业类型名称!')
        return
      }
      const params = {
        name: row.name
      }
      if (row.id) {
        params.id = row.id
      }
      saveExerciseConf(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success(`${row.id ? '更新' : '保存'}作业类型成功!`)
          row.id = data.id
        }
      })
    },
    receiveSubmitDate (val) {
      this.submitDate = val
      this.filter.submitDateStart = val[0] + ' 00:00:00'
      this.filter.submitDateEnd = val[1] + ' 23:59:59'
    },
    receiveOperateDate (val) {
      this.operateDate = val
      this.recordFilter.queryTimeStart = val[0] + ' 00:00:00'
      this.recordFilter.queryTimeEnd = val[1] + ' 23:59:59'
    },
    // 作业判卷
    toGrading(row) {
      this.dialogTitle = '作业判卷'
      this.scoreForm.practicalContentCreation = row.practicalContentCreation || undefined
      this.scoreForm.practicalLanguageExpression = row.practicalLanguageExpression || undefined
      this.scoreForm.practicalScreenPresence = row.practicalScreenPresence || undefined
      this.scoreForm.practicalDataAnalysis = row.practicalDataAnalysis || undefined
      this.scoreForm.practicalPlanOperation = row.practicalPlanOperation || undefined
      const t = this.scoreForm
      const r1 = add(t.practicalContentCreation || 0, t.practicalLanguageExpression || 0)
      const r2 = add(t.practicalScreenPresence || 0, t.practicalDataAnalysis || 0)
      const r3 = add(r1, r2)
      this.targetPracticalScore = add(r3, t.practicalPlanOperation || 0)
      this.type = 'showGrading'
      this.targetGradingStatus = row.gradingStatus
      this.targetPracticalId = row.id
      this.searchWorkRecord()
      this.dialogVisable = true
    },
    // 判卷记录
    viewGradingRecord(id) {
      this.$refs.RecordEl.init(id)
    },
    // 作业记录
    viewWorkRecord(row) {
      this.dialogTitle = '作业记录'
      this.targetPracticalId = row.id
      this.searchWorkRecord()
      this.dialogVisable = true
    },
    // 批量发布成绩
    batchPublish () {
      this.$confirm(`确认批量发布成绩?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.multipleSelection.map(({ id }) => id).join(',')
        const params = { ids }
        batchPublishGrading(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('批量发布成绩成功!')
            this.getListPage()
          }
        })
      })
    },
    // 发布成绩
    handlePublish(id) {
      this.$confirm(`确认发布成绩?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await publishGrading({ id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('成绩发布成功！')
        this.getListPage()
      })
    },
    handlePage(current) {
      this.filter.page = current
      this.getListPage()
    },
    // 确认判卷 / 确认判卷并发布成绩
    handleSubmit(status) {
      this.$refs.scoreFormEl.validate(valid => {
        if (valid) {
          this.saveing = true
          const params = {
            ...this.scoreForm,
            userPracticalId: this.targetPracticalId,
            status
          }
          gradingPractical(params).then(({ code }) => {
            if (code === 0) {
              const t = status === 1 ? '判卷成功!' : '判卷并发布成绩成功!'
              this.$message.success(t)
              this.getListPage()
              this.handleCloseDialog()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    // 重新判卷
    handleReGrading() {
      this.type = 'showGrading'
      this.targetGradingStatus = 1
    },
    handlePageSize(size) {
      this.filter.limit = size
      this.getListPage()
    },
    searchWorkRecord() {
      this.recordFilter.page = 1
      this.getExerciseRecordListPage()
    },
    resetWorkRecord () {
      this.operateDate = []
      this.recordFilter = this.$options.data().recordFilter
      this.getExerciseRecordListPage()
    },
    async getExerciseRecordListPage () {
      const params = {
        ...this.recordFilter,
        userPracticalId: this.targetPracticalId
      }
      delete params.total
      const { data } = await getExerciseRecordListPage(params)
      const { records, total } = data
      this.recordFilter.total = Number(total)
      this.workRecordData = records
    },
    handleRecordPage(current) {
      this.recordFilter.page = current
      this.getExerciseRecordListPage()
    },
    handleRecordPageSize(size) {
      this.recordFilter.limit = size
      this.getExerciseRecordListPage()
    },
    handleCloseDialog() {
      this.dialogTitle = ''
      this.operateDate = []
      this.recordFilter = this.$options.data().recordFilter
      this.type = ''
      this.targetPracticalId = ''
      this.targetGradingStatus = 0
      this.dialogVisable = false
    },
    handleCloseStandardDialog () {
      this.standardEditForm = this.$options.data().standardEditForm
      this.dialogStandardVisable = false
    },
    handleCloseExerciseConfDialog() {
      this.exerciseConfList = []
      this.handleGetExerciseConfList()
      this.dialogExerciseConfVisable = false
    },
    fliteRData(row, column, cellValue, index) {
      const _value = row[column.property]
      if (_value) {
        return _value
      } else {
        return '--'
      }
    },
    changeInput(e) {
      if (e.target.value.indexOf('.') >= 0) {
        e.target.value = e.target.value.substring(0, e.target.value.indexOf('.') + 2);
      }
    },
    getRowKeys (row) {
      return row.id
    },
    checkSelectable (row) {
      return row.publishStatus === 1
    },
    // 列表选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    }
  },
  filters: {
    filterTypeName (val) {
      const t = exerciseConfList.find(({ id }) => id === val)
      const r = t ? t.name : '--'
      return r
    }
  }
}
</script>

<style lang="scss" scoped>
.el-icon-circle-plus-outline {
  font-size: 16px;
}
.dilog-module-title {
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 8px;
  margin: 10px 0 18px;
  border-bottom: 1px solid #999;
}
.red {
  display: inline-block;
  width: 100px;
  margin-left: 32px;
}
</style>
